import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import React from "react";
import { css } from "styled-components";

const enum fields {
    images = "images",
    title = "title",
}

interface SlideModel {
    fields: {
        imageTitle: string;
        image: string;
        imageLink: LinkFieldValue;
        findoutLink: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.images]: SlideModel[];
    };
}

type Props = OwnProps;

export interface InfoCardStyles {
    Title?: InjectableCss;
    infoCardContainer?: GridContainerProps;
    infoCardImage?: LazyImageProps;
    infoCardLink?: LinkPresentationProps;
    infoCardDiv?: GridItemProps;
    imageTitle?: InjectableCss;
    main?: InjectableCss;
    svg?: InjectableCss;
    moreLink?: InjectableCss;
    findoutLink?: InjectableCss;
}

export const infoCardStyles: InfoCardStyles = {
    infoCardContainer: {
        gap: 52,
        css: css`
            margin: 0 auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100vw;
            /* min-width: 1303px; */

            position: relative;
            /* left: -9%; */

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-width: auto;
                    `,
                    css`
                        min-width: auto;
                    `,
                    css`
                        min-width: auto;
                    `,
                    css`
                        min-width: auto;
                    `,
                    css``,
                ])}
        `,
    },
    infoCardDiv: {
        width: [12, 12, 12, 4, 4],
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: inherit;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 9px 20px;
                    `,
                    css`
                        padding: 9px 20px;
                    `,
                    css`
                        padding: 9px 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    infoCardLink: {
        css: css`
            width: 100%;
            position: relative;
            background: #fff;
            box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.5);
            &::before {
                content: "";
                background-image: linear-gradient(to left top, rgb(137 11 11) 0%, rgb(12 12 12 / 28%) 50%);
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width: 100%;
                height: 100%;
                z-index: 2;
                transition: 0.5s all;
                opacity: 0;
            }
            &:hover::before {
                opacity: 1;
            }
            span {
                width: 100%;
            }
            &:focus {
                outline-color: transparent;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: -45px 0;
                        width: 105%;
                    `,
                    css`
                        margin: -45px 0;
                        width: 105%;
                    `,
                    css`
                        width: max-content;
                    `,
                ])}
        `,
    },
    infoCardImage: {
        css: css`
            width: 100%;
            display: flex;

            img {
                object-fit: cover;
                aspect-ratio: 4.1/4.1;
                display: flex;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css``,
                    ])}
            }
        `,
    },
    imageTitle: {
        css: css`
            font-style: normal;
            font-family: "Roboto";
            font-weight: 700;
            font-size: 20px;
            line-height: 28px;
            margin-top: 16px;
            margin-left: -187px;
            position: absolute;
            bottom: 60px;
            text-align: center;
            color: #fff;
            text-transform: capitalize;
            display: flex;
            justify-content: space-around;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 8px;
                        position: relative;
                        top: -36px;
                        font-size: 17px;
                        text-align: justify;
                        font-weight: 700;
                        margin-left: 12px;
                    `,
                    css`
                        margin-top: 8px;
                        position: relative;
                        top: -36px;
                        font-size: 17px;
                        text-align: justify;
                        font-weight: 700;
                        margin-left: 12px;
                    `,
                    css`
                        margin-top: 8px;
                        position: relative;
                        top: -36px;
                        font-size: 17px;
                        text-align: justify;
                        font-weight: 700;
                        margin-left: 12px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    moreLink: {
        css: css`
            text-align: left;

            color: #fff;
            text-shadow: 0 0 #000;
            font-style: normal;
            font-family: "Roboto";
            -webkit-text-decoration: underline;
            text-decoration: underline;
            font-weight: 600;
            font-size: 15px;
            line-height: 28px;
            margin-top: 31px;
            margin-left: -186px;
            position: absolute;
            bottom: 30px;
            text-align: center;
            text-transform: uppercase;
            display: flex;
            justify-content: space-around;
            align-items: center;
            z-index: 100;

            &:focus {
                outline-color: #fff;
                outline-style: solid;
                outline-width: 2px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 8px;
                        position: relative;
                        top: -34px;
                        font-size: 14px;
                        text-align: justify;
                        font-weight: 700;
                        margin-left: 119px;
                    `,
                    css`
                        margin-top: 8px;
                        position: relative;
                        top: -34px;
                        font-size: 14px;
                        text-align: justify;
                        font-weight: 700;
                        margin-left: 119px;
                    `,
                    css`
                        margin-top: 8px;
                        position: relative;
                        top: -34px;
                        font-size: 14px;
                        text-align: justify;
                        font-weight: 700;
                        margin-left: 119px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    findoutLink: {
        css: css`
            &:focus {
                outline-color: #fff;
                outline-style: solid;
                outline-width: 2px;
            }

            ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [css``, css``, css``, null, null])}
        `,
    },

    svg: {
        css: css`
            font-style: normal;
            font-weight: 600;
            font-size: 35px;
            line-height: 28px;
            margin-top: 16px;
            margin-left: 190px;
            position: absolute;
            bottom: 60px;
            text-align: center;
            display: flex;
            color: #fff;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-style: normal;
                        color: #fff;
                        font-weight: 600;
                        font-size: 35px;
                        line-height: 28px;
                        margin-left: 334px;
                        bottom: 219px;
                        text-align: center;
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        left: -47%;
                    `,
                    css`
                        font-style: normal;
                        color: #fff;
                        font-weight: 600;
                        font-size: 35px;
                        line-height: 28px;
                        margin-left: 334px;
                        bottom: 219px;
                        text-align: center;
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        left: -47%;
                    `,
                    css`
                        font-style: normal;
                        color: #fff;
                        font-weight: 600;
                        font-size: 35px;
                        line-height: 28px;
                        margin-left: 334px;
                        bottom: 219px;
                        text-align: center;
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        left: -47%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    Title: {
        css: css`
            text-align: center;
            text-transform: uppercase;

            margin-bottom: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 14px;

                        padding-bottom: 14px;
                    `,
                    css`
                        margin-bottom: 14px;

                        padding-bottom: 14px;
                    `,
                    css`
                        margin-bottom: 14px;

                        padding-bottom: 14px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    main: {
        css: css`
            margin-bottom: 20px;
            max-width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 60px;
                    `,
                    css`
                        margin-top: 60px;
                    `,
                    css`
                        margin-top: 60px;
                    `,
                    null,
                    null,
                ])},
            >${GridWrapper} {
                max-width: 100%;
                > ${GridOffset} {
                    margin: 0px !important;
                    max-width: 100%;
                }
            }
        `,
    },
};

const styles = infoCardStyles;

const ImageGrid: React.FC<Props> = ({ fields }) => {
    const buttonLinks = useGetLinks(fields.images, o => o.fields.imageLink);
    return (
        <StyledWrapper {...styles.main}>
            <GridContainer {...styles.infoCardContainer}>
                {fields.images.map((slide, index) => (
                    <GridItem key={uniqueId()} {...styles.infoCardDiv}>
                        <Link
                            href={buttonLinks[index].url}
                            {...styles.infoCardLink}
                            onClick={() =>
                                window.open(
                                    slide.fields.findoutLink,
                                    "_blank",
                                    "width=600, height=500, top=230, left=400",
                                )
                            }
                        >
                            <LazyImage src={slide.fields.image} {...styles.infoCardImage}></LazyImage>
                        </Link>
                        <Link href={buttonLinks[index].url}>
                            <StyledWrapper {...styles.imageTitle}>{slide.fields.imageTitle}</StyledWrapper>
                            <Link href={slide.fields.findoutLink} {...styles.findoutLink} target="_blank">
                                <Typography {...styles.moreLink}>Find Out More</Typography>
                            </Link>
                            <StyledWrapper {...styles.svg}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    margin-left="109"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-play-circle"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polygon points="10 8 16 12 10 16 10 8"></polygon>
                                </svg>
                            </StyledWrapper>
                        </Link>
                    </GridItem>
                ))}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ImageGrid,
    definition: {
        group: "Basic",
        displayName: "ImageLink",
        fieldDefinitions: [
            {
                name: fields.images,
                editorTemplate: "ListField",
                defaultValue: [],
                fieldType: "General",
                getDisplay: (item: HasFields) => {
                    return item.fields.slideTitle;
                },
                fieldDefinitions: [
                    {
                        name: "imageTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "imageLink",
                        editorTemplate: "TextField",
                        displayName: "Youtube Link",
                        defaultValue: "",
                    },
                    {
                        name: "findoutLink",
                        editorTemplate: "TextField",
                        displayName: "Find Out Link",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
